import { z } from 'zod';
// Identity/user profile analytics DTOs and query scopes shared by the admin,
// customer, and backend profile surfaces. snake_case fields are the response
// wire contract.
export const profileRangeSchema = z.object({
    from: z.string().optional(),
    to: z.string().optional(),
});
export const customerProfileScopeSchema = z.object({
    projectId: z.string(),
    userId: z.string(),
});
export const identityProfileScopeSchema = z.object({
    organizationId: z.string(),
    identityId: z.string().optional(),
    userId: z.string().optional(),
    projectId: z.string().optional(),
    from: z.string(),
    to: z.string(),
});
export const profileMetricsSchema = z.object({
    events: z.number(),
    pageviews: z.number(),
    sessions: z.number(),
    duration_avg_sec: z.number(),
    duration_p90_sec: z.number(),
    bounce_rate: z.number(),
    active_days: z.number(),
    first_seen: z.string().nullable(),
    last_seen: z.string().nullable(),
    revenue: z.number(),
});
export const profileActivityPointSchema = z.object({
    day: z.string(),
    count: z.number(),
});
export const profileTopPageSchema = z.object({
    url: z.string(),
    count: z.number(),
});
export const profileReferrerSchema = z.object({
    referrer: z.string(),
    count: z.number(),
});
export const profileTimeseriesPointSchema = z.object({
    day: z.string(),
    pageviews: z.number(),
    events: z.number(),
});
export const profileDeviceGeoCurrentSchema = z.object({
    device: z.string().nullable(),
    os: z.string().nullable(),
    browser: z.string().nullable(),
    country: z.string().nullable(),
    city: z.string().nullable(),
    screen: z.string().nullable(),
    language: z.string().nullable(),
});
export const profileDeviceGeoSchema = z.object({
    current: profileDeviceGeoCurrentSchema.nullable(),
    countries: z.array(z.object({ country: z.string(), count: z.number() })),
    devices: z.array(z.object({ device: z.string(), count: z.number() })),
    browsers: z.array(z.object({ browser: z.string(), count: z.number() })),
    os: z.array(z.object({ os: z.string(), count: z.number() })),
});
export const profileSessionSchema = z.object({
    session_id: z.string(),
    started_at: z.string(),
    ended_at: z.string(),
    duration_sec: z.number(),
    pageviews: z.number(),
    events: z.number(),
    entry_path: z.string().nullable(),
    exit_path: z.string().nullable(),
    country: z.string().nullable(),
    device: z.string().nullable(),
});
export const profileSessionsResponseSchema = z.object({
    sessions: z.array(profileSessionSchema),
    cursor: z.string().nullable(),
});
export const customerProfileIdentitySchema = z.object({
    identity_id: z.string().nullable(),
    email: z.string().nullable().optional(),
    // The subject's canonical user_id (primary alias, falling back to the
    // identity's primary_user_id) — so the profile can show the real user_id even
    // when the page was linked by the resolved identifier (an identity_id UUID).
    // Null when the subject was never identified with a user_id.
    user_id: z.string().nullable().optional(),
    // Stored identity traits (merged current state), or {} when the user is
    // anonymous/unidentified. Powers the profile Properties tab.
    traits: z.record(z.string(), z.unknown()).optional(),
});
// Empty-but-valid shapes returned when ClickHouse reads are disabled.
export const EMPTY_PROFILE_METRICS = {
    events: 0,
    pageviews: 0,
    sessions: 0,
    duration_avg_sec: 0,
    duration_p90_sec: 0,
    bounce_rate: 0,
    active_days: 0,
    first_seen: null,
    last_seen: null,
    revenue: 0,
};
export const EMPTY_PROFILE_DEVICE_GEO = {
    current: null,
    countries: [],
    devices: [],
    browsers: [],
    os: [],
};
export const EMPTY_PROFILE_SESSIONS = {
    sessions: [],
    cursor: null,
};
//# sourceMappingURL=profile.js.map